import { createContext, useState, useEffect } from 'react';
import { getConfig } from "@api";
import { PageLoader } from "@components";
export const ConfigurationContext = createContext();

export const ConfigurationProvider = ({children }) => {
  const [config, setConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!config) {
      const fetchConfig = async () => {
        const data = await getConfig();
        setConfig(data);

        setIsLoading(false);
      };
      fetchConfig();
    }
    else {
      setIsLoading(false);
    }
  }, [config]);

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <ConfigurationContext.Provider value={{ config, setConfig }}>
      {children}
    </ConfigurationContext.Provider>
  );
};


